import { getPayments, createPayment, updatePayment, deletePayment } from "./payments.service";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const QUERY_KEY = "payments";

export const useGetPayments = (params) => {
  return useQuery({
    queryFn: () => getPayments(params),
    queryKey: [QUERY_KEY, params],
    enabled: !!params,
  })
};

export const useCreatePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createPayment(data),
    onSuccess: () => {
      // Invalidate payments query to refetch updated list after creating a payment
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    }
  });
};

export const useUpdatePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ paymentId, data }) => updatePayment(paymentId, data),
    onSuccess: () => {
      // Invalidate payments query to refetch updated list after updating a payment
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    }
  });
};

export const useDeletePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({paymentId}) => deletePayment(paymentId),
    onSuccess: () => {
      // Invalidate payments query to refetch updated list after deleting a payment
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    }
  });
};
